import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Ocultar Buscador ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "open-messages-finder"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "message-date" }
const _hoisted_10 = { class: "message-text" }
const _hoisted_11 = { class: "message-user" }
const _hoisted_12 = {
  key: 3,
  class: "no-messages-found"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "No se han encontrado mensajes", -1)
const _hoisted_14 = [
  _hoisted_13
]

import { ref } from "vue";
import { TicketModule } from "@/store/modules/Ticket";
import { InterfaceId, Interfaces, InterfacesColor } from "@/types/tickets"
import { coreApi } from "@/conection";
import { AuthModule } from "@/store/modules/Auth";
import { DateTime } from "ts-luxon";

// Interface
interface IFoundMessage {
	_id: string;
	ticket: string;
	message: string;
	agent?: string;
	client?: string;
	interface: string;
	date: string;
}

// Data

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const _height = ref(window.innerHeight - 109);
const pattern = ref("");
const trySearch = ref(false);
const loading = ref(false);
const messages = ref<IFoundMessage[]>([]);

// events
window.addEventListener(
	"resize",
	() => (_height.value = window.innerHeight - 79)
);

// Methods
function search() {
	if (pattern.value.trim().length > 0) {
		loading.value = true;
		trySearch.value = true;
		coreApi.defaults.headers.common["access-token"] = AuthModule.token ?? "";
		coreApi
			.post(`api/message/search/${TicketModule.currentTicket?.client[0]._id}`, {
				pattern: pattern.value.trim(),
			})
			.then(response => {
				messages.value = response.data.messages as IFoundMessage[];
				loading.value = false;
			});
	} else {
		trySearch.value = false;
	}
}
async function fetchOldTicket(message: IFoundMessage) {
	if (!TicketModule.LastTickets.find(t => t._id === message.ticket)) {
		const response = await coreApi.post(`api/ticket/search/${message.ticket}`);
		TicketModule.lastTicketUpsert(response.data.ticket)
	}

	TicketModule.previewOldTicket({
		ticketId: message.ticket,
		date: message.date,
	});
}
async function getTicket(message: IFoundMessage) {
	if (TicketModule.currentRoomID === message.ticket) {
		TicketModule.setRoomId(null);
		setTimeout(() => {
			TicketModule.setRoomId(message.ticket);
			fetchOldTicket(message);
		});
	} else fetchOldTicket(message);
}

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_unref(TicketModule).openedSearchSidebar)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        style: _normalizeStyle({
			height: `${_height.value}px`,
			'overflow-y': 'hidden',
			'min-width': '340px',
		}),
        class: "p-3"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_base_button, {
            onClick: _cache[0] || (_cache[0] = () => _unref(TicketModule).setOpenedSearchSidebar(false)),
            style: {"width":"100%"},
            type: "secondary"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_card, {
          "body-style": "padding: 0",
          style: _normalizeStyle(`height: ${_height.value - 70}px`),
          class: "my-2"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: pattern.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((pattern).value = $event)),
              onInput: search
            }, {
              prefix: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              id: "found-messages",
              style: _normalizeStyle(`max-height: ${_height.value - 130}px`)
            }, [
              (!trySearch.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", null, " Busca Mensajes de " + _toDisplayString(_unref(TicketModule).currentRoom?.roomName), 1)
                  ]))
                : (loading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                        return _createVNode(_component_el_skeleton, {
                          class: "loading",
                          key: i,
                          rows: 1,
                          animated: ""
                        })
                      }), 64))
                    ]))
                  : (messages.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: message._id,
                            class: "message-card",
                            onClick: ($event: any) => (getTicket(message))
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(`d-flex justify-content-between text-${_unref(InterfacesColor)[message.interface as InterfaceId]}`)
                            }, [
                              _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(DateTime).fromISO(message.date).toLocaleString(
										_unref(DateTime).DATE_SHORT
									) === _unref(DateTime).now().toLocaleString(_unref(DateTime).DATE_SHORT)
										? _unref(DateTime).fromISO(message.date).toLocaleString(
											_unref(DateTime).TIME_SIMPLE
										)
										: _unref(DateTime).fromISO(message.date).toLocaleString(
											_unref(DateTime).DATETIME_SHORT
										)), 1),
                              _createElementVNode("i", {
                                class: _normalizeClass(`fab fa-${_unref(Interfaces)[message.interface as InterfaceId]}`)
                              }, null, 2)
                            ], 2),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(message.agent ? message.agent : message.client) + ": ", 1),
                              _createTextVNode(" " + _toDisplayString(message.message), 1)
                            ])
                          ], 8, _hoisted_8))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
            ], 4)
          ]),
          _: 1
        }, 8, ["style"])
      ], 4))
    : _createCommentVNode("", true)
}
}

})